module.exports = {
      id: "icon-center-grid-payment-usage",
      viewBox: "0 0 59 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-center-grid-payment",
      toString: function () {
        return this.url;
      }
    }